import { render, staticRenderFns } from "./InfusionBagVolumeSelect.vue?vue&type=template&id=506d81b2&scoped=true&"
import script from "./InfusionBagVolumeSelect.vue?vue&type=script&lang=js&"
export * from "./InfusionBagVolumeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506d81b2",
  null
  
)

export default component.exports